import React from 'react'

const HomeRemodelIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="currentColor"
      className={className}
      style={{ display: 'block' }}
    >
      {/* House Outline */}
      <path d="M32,5.17,59.48,21.66V59.48h-55V21.66L32,5.17M32,.59.59,19.44v44H63.41v-44L32,.59Z" />

      {/* Structure / Blueprint details */}
      <path d="M16.94,57.89H9.07V43.58L20.24,35l8.25,7.78ZM13,54h2l8.22-10.73L20,40.17l-7,5.35Z" />

      {/* Remodeling Tools / Elements */}
      <path d="M45.45,46.36,37.39,38.3,39,36.68a2.41,2.41,0,0,0-1.42-.61c-1.64-.12-3.52,1.48-4,2l-1.39,1.52L23.57,31l1.82-1.35a10,10,0,0,0,3.38-5.13c.14-.67-2.15-2.59-3-3.31-1.88-1.56-3.5-2.91-3.08-4.82A3.26,3.26,0,0,1,25.34,14c5.39-1.46,16.2,6.86,19.39,9.44l.55.45.14.69c.84,4.19,1.93,5,2.14,5.07L48.73,29l1.11,1.13c1.81,1.85,3.86,3.92,4.31,4.33L56,35.67ZM42.94,38.3l2.5,2.5L50.17,36c-.56-.56-1.33-1.33-2.37-2.4A3.9,3.9,0,0,1,46,33.29c-2-.85-3.4-3.21-4.3-7.2C37,22.33,31.14,18.69,28,17.91l.3.26c2.22,1.84,5,4.14,4.35,7.13a12.84,12.84,0,0,1-3.24,5.95l2.82,2.85a8.67,8.67,0,0,1,5.7-1.94,7.12,7.12,0,0,1,5.42,3.54L44.2,37Z" />

      {/* Interior / Measure Details */}
      <polygon points="21.67 39.07 28.04 32.69 30.76 35.41 24.57 41.8 21.67 39.07" />
    </svg>
  )
}

export default HomeRemodelIcon
